import { render, staticRenderFns } from "./MfaRecoveryCodes.vue?vue&type=template&id=9db00e78&scoped=true&"
import script from "./MfaRecoveryCodes.vue?vue&type=script&lang=js&"
export * from "./MfaRecoveryCodes.vue?vue&type=script&lang=js&"
import style0 from "./MfaRecoveryCodes.vue?vue&type=style&index=0&id=9db00e78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9db00e78",
  null
  
)

export default component.exports